/*
 * @Author: Liux
 * @Date: 2019-09-27 06:23:51
 * @LastEditor: Liux
 * @LastEditTime: 2019-09-29 02:13:55
 */
import { Injectable, TemplateRef } from '@angular/core';
import { AdDashboardWidgetEventService } from './ad-dashboard-widget-event.service';
import { AdDashboardBoxButton } from './ad-dashboard-box/ad-dashboard-box.component';
import { AdDashboarxBoxSize } from './ad-dashboard-box/ad-dashboard-box.component';

@Injectable()
export class AdDashboardConnectBoxServiceService {
  constructor(private weidgetEventService: AdDashboardWidgetEventService) {}
  public resize(size: AdDashboarxBoxSize) {
    this.weidgetEventService.onResize.emit(size);
  }

  public updateSetting(obj: any) {
    this.weidgetEventService.onSettingChange.emit(obj);
  }

  public openLoading() {
    this.weidgetEventService.onLoading.emit(true);
  }

  public closeLoading() {
    this.weidgetEventService.onLoading.emit(false);
  }

  public updateRightButtons(buttons: AdDashboardBoxButton[]) {
    this.weidgetEventService.onRightButtonChange.emit(buttons);
  }

  public updateRightHeaderTemplate(tpl: TemplateRef<any>) {
    this.weidgetEventService.onRightHeaderTemplateChange.emit(tpl);
  }
}
